import { useExperiment } from "../useExperiment";
import { useFlippers } from "../useFlippers";
import { useIsFs2JanRelease } from "../useIsFs2JanRelease";

// purposefully only setting one group to assist in December release strategy
const useGaiaCareCenterExperiment = (shouldBeExperimented = true) => {
  const [isGaiaCareCenterEnabled] = useFlippers("gaia_care_center");
  const isJanReleaseGroup = useIsFs2JanRelease();

  const experimentGroup = useExperiment({
    experiment: "care_center_experiment",
    groups: ["CARE_CENTER"],
    owner: "gaia",
    shouldLog: shouldBeExperimented && isGaiaCareCenterEnabled,
    e2eGroup: "CONTROL",
  });
  if (isJanReleaseGroup) {
    return true;
  }
  if (isGaiaCareCenterEnabled) {
    return shouldBeExperimented && experimentGroup === "CARE_CENTER";
  }

  return false;
};

export { useGaiaCareCenterExperiment };
